/** @type {{ clickTarget: Element, x: number, y: number, moved: boolean } | null} */
let activePointer = null;

/** @type {WeakSet<Element>} */
const suppressNextClick = new WeakSet();

const DRAG_THRESHOLD = 50;

let initialized = false;

/**
 * Tracks pointer movement on elements with `on:click` inside Swiper containers.
 * Only the dragged element's immediate click release is suppressed.
 */
export function initSwiperClickGuard() {
  if (initialized) return;
  initialized = true;

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointerup', onPointerUp, true);
  document.addEventListener('pointercancel', onPointerUp, true);
}

/** @param {PointerEvent} event */
function onPointerDown(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const clickTarget = target.closest('[on\\:click]');
  if (!clickTarget?.closest('.swiper')) {
    activePointer = null;
    return;
  }

  activePointer = {
    clickTarget,
    x: event.clientX,
    y: event.clientY,
    moved: false,
  };
}

/** @param {PointerEvent} event */
function onPointerMove(event) {
  if (!activePointer) return;

  const distance = Math.hypot(event.clientX - activePointer.x, event.clientY - activePointer.y);
  if (distance > DRAG_THRESHOLD) {
    activePointer.moved = true;
  }
}

function onPointerUp() {
  if (activePointer?.moved) {
    suppressNextClick.add(activePointer.clickTarget);
  }

  activePointer = null;
}

/**
 * @param {Element} clickElement - The element resolved by `on:click` delegation
 * @returns {boolean}
 */
export function shouldSuppressSwiperClick(clickElement) {
  if (!suppressNextClick.has(clickElement)) return false;

  suppressNextClick.delete(clickElement);
  return true;
}
